class HamburgerMenu {
    constructor() {
        this.$sideNav = jQuery('#side-nav');

        this.init();
    }

    openHamburgerMenu() {
        this.$sideNav.addClass('open');
    }

    closeHamburgerMenu() {
        this.$sideNav.removeClass('open');
    }

    setupEvents() {
        jQuery('#btn-open-nav').on('click', e => {
            e.stopPropagation();
            this.openHamburgerMenu();
        });

        jQuery('#btn-close-nav').on('click', () => {
            this.closeHamburgerMenu();
        });

        jQuery('body').on('click', e => {
            this.closeHamburgerMenu();
        });

        jQuery('#side-nav').on('click', e => {
            e.stopPropagation();
        });

        jQuery('#side-nav .title').on('click', e => {
            e.preventDefault();
        });
    }

    init() {
        this.setupEvents();
    }
}

export default HamburgerMenu;
